import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

function isEmptyArray(value) {
    return Array.isArray(value) && isEmpty(value);
}
function areEmptyArrays(...values) {
    return values.every(isEmptyArray);
}
function isEmptyObject(value) {
    return isObject(value) && !Array.isArray(value) && isEmpty(value);
}
function areEmptyObjects(...values) {
    return values.every(isEmptyObject);
}
function templateJoin(values, template) {
    return values.reduce((acc, curr) => `${acc}${isString(curr) ? template(curr) : ''}`, '');
}

export { areEmptyArrays, areEmptyObjects, templateJoin };
